module.exports = __webpack_public_path__ + "static/media/aiPlato_Practice_Tests_edited.ac0198fb.mp4";